export default __webpack_public_path__ + "static/article-travel-top-10-destinations-2a7b0218c0de12996569d450d89741fd.jpg";